module.exports = __webpack_public_path__ + "static/media/level3_flag.82b24d85.svg";